function setClasses(carouselEl) {
    const items = Array.from(carouselEl.querySelectorAll(".carousel-item"));
    if (items.length < 2) return;

    items.forEach((el) => el.classList.remove("is-prev", "is-next"));

    const activeIndex = items.findIndex((el) => el.classList.contains("active"));
    if (activeIndex === -1) return;

    const prevIndex = (activeIndex - 1 + items.length) % items.length;
    const nextIndex = (activeIndex + 1) % items.length;

    items[prevIndex].classList.add("is-prev");
    items[nextIndex].classList.add("is-next");
}

/**
 * Initializes "peek" behavior for a Bootstrap carousel.
 * Safe to call sitewide.
 */
export function initStoryCarousel(selector = ".port-carousel") {
    const carousels = Array.from(document.querySelectorAll(selector));
    if (!carousels.length) return;

    for (const carouselEl of carousels) {
        // initial
        setClasses(carouselEl);

        // after each slide completes
        carouselEl.addEventListener("slid.bs.carousel", () => setClasses(carouselEl));

        // if something else triggers changes (optional)
        carouselEl.addEventListener("shown.bs.carousel", () => setClasses(carouselEl));
    }
}